import React from 'react';
import { CheckIcon, ClockIcon, UtensilsIcon, ShoppingBagIcon } from 'lucide-react';
const Features = () => {
  return <section className="w-full py-16 px-6 md:px-12 lg:px-24 bg-[#F9F4EE]" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <div className="flex flex-col md:flex-row items-center gap-12 mb-16" data-id="element-39">
          <div className="w-full md:w-1/2" data-id="element-40">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m7RG7sBiii6xpwwqkTE2uv/ChatGPT_Image_Sep_11%2C_2025%2C_03_13_38_PM.png" alt="Ebook de recetas" className="w-full rounded-lg shadow-xl" data-id="element-41" />
          </div>
          <div className="w-full md:w-1/2 space-y-6" data-id="element-42">
            <h2 className="text-3xl font-bold text-[#C17A47]" data-id="element-43">
              Presentamos: 20 Cenas Listas en 15 Minutos
            </h2>
            <p className="text-lg text-[#6B5A45]" data-id="element-44">
              Un ebook creado por mamás reales, para mamás reales.
            </p>
            <ul className="space-y-4" data-id="element-45">
              <li className="flex items-start gap-3" data-id="element-46">
                <CheckIcon className="w-6 h-6 text-[#C17A47] mt-1 flex-shrink-0" data-id="element-47" />
                <span className="text-[#6B5A45]" data-id="element-48">
                  20 recetas express listas en menos de 15 min
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-49">
                <CheckIcon className="w-6 h-6 text-[#C17A47] mt-1 flex-shrink-0" data-id="element-50" />
                <span className="text-[#6B5A45]" data-id="element-51">
                  Opciones sin horno: solo estufa, microondas o en frío
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-52">
                <CheckIcon className="w-6 h-6 text-[#C17A47] mt-1 flex-shrink-0" data-id="element-53" />
                <span className="text-[#6B5A45]" data-id="element-54">
                  Snacks nutritivos para la lonchera que los niños realmente
                  comen
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-55">
                <CheckIcon className="w-6 h-6 text-[#C17A47] mt-1 flex-shrink-0" data-id="element-56" />
                <span className="text-[#6B5A45]" data-id="element-57">
                  Ingredientes simples, accesibles y económicos
                </span>
              </li>
            </ul>
            <p className="text-lg text-[#6B5A45] italic" data-id="element-58">
              Nada raro. Nada caro. Solo lo que ya tienes en tu cocina.
            </p>
          </div>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-59">
          <h3 className="text-2xl font-semibold text-[#C17A47] mb-4" data-id="element-60">
            Según la American Heart Association
          </h3>
          <p className="text-lg text-[#6B5A45]" data-id="element-61">
            Cocinar en casa con recetas simples puede reducir hasta 30% el
            consumo de ultraprocesados. Eso significa salud, ahorro y energía
            real para toda la familia.
          </p>
        </div>
      </div>
    </section>;
};
export default Features;